import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import {
  TrackingParamsContextProvider,
  AnalyticsProvider,
  initSentry,
} from '@app/analytics';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AppRouter } from './pages/AppRouter';
import { ThemeProvider } from './ThemeProvider';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './i18n';
import {
  ToastContainer,
  ScrollToTop,
  MaintenanceGate,
  NotFound,
} from '@app/core';

initSentry({
  dsn: process.env.NX_SENTRY_DSN as string,
  app: 'tandemz-participant',
});

const queryClient = new QueryClient();

export const App = () => (
  <Sentry.ErrorBoundary fallback={<NotFound />}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AnalyticsProvider container="xoe5d0Ki">
          <ThemeProvider>
            <I18nextProvider i18n={i18n}>
              <ToastContainer />
              <MaintenanceGate>
                <TrackingParamsContextProvider>
                  <ScrollToTop />
                  <AppRouter />
                </TrackingParamsContextProvider>
              </MaintenanceGate>
            </I18nextProvider>
          </ThemeProvider>
        </AnalyticsProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);
